'use client';

import Image from 'next/image';
import { clsx } from 'clsx';

const trailingSlash =
  process.env['NEXT_PUBLIC_TRAILING_SLASH'] === 'true' ? '/' : '';

const basePath = process.env['NEXT_PUBLIC_BASE_PATH'] || '';

export const OgImage = ({
  alt,
  ogParams,
  height,
  width,
  className,
}: {
  alt: string;
  ogParams: string;
  height: number;
  width: number;
  className?: string;
}) => {
  return (
    <Image
      itemProp='image'
      alt={alt}
      src={`${basePath}/api/og/how-to${trailingSlash}?${ogParams}`}
      loader={({ src }) => `${src}&w=${width}&q=${65}`}
      height={height}
      width={width}
      className={clsx('h-full w-full', className)}
      priority={false}
      loading={'lazy'}
    />
  );
};
